/* ============
 * Slot Mixin
 * ============
 *
 * Mixins are used to easily expand Vue components.
 * This slot-mixin, will add the hasSlot-method
 * to the specified Vue component.
 */

import Vue from 'vue';
import { Mixin } from 'vue-mixin-decorator';

@Mixin
export class SlotMixin extends Vue {
  /**
   * Method used to check if a Vue component has a slot.
   * @param slotName The name of the slot.
   * @returns {boolean} Whether the component has a slot.
   */
  hasSlot (slotName = 'default'):boolean {
    return !!this.$slots[slotName];
  }
}
